import {atom} from "jotai";


export const atomMenuMobile = atom(false);
